import { render, staticRenderFns } from "./Telephones.vue?vue&type=template&id=91623250&scoped=true&"
import script from "./Telephones.vue?vue&type=script&lang=js&"
export * from "./Telephones.vue?vue&type=script&lang=js&"
import style0 from "./Telephones.vue?vue&type=style&index=0&id=91623250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91623250",
  null
  
)

export default component.exports